import React, { Component, Fragment } from 'react';
import SelectSearch from 'react-select-search';
import { getSchoolFormationRequest } from '../../services/api.service';
import AlreadyMemberBlock from './components/already-member-block';
import { List } from './sign-up.styled';
import './select.scss';

export const SCHOOL_TYPES = [
  {key: 'ING', title: 'École d’ingénieur'},
  {key: 'BUS', title: 'École de commerce'},
  {key: 'ENS', title: 'École Normale Supérieure'},
  {key: 'SCP', title: 'Institut d’Etudes Politiques'},
  {key: 'DRO', title: 'Faculté de Droit' },
  {key: 'MED', title: 'Faculté de Médecine' },
  {key: 'SCI', title: 'Faculté de Sciences' },
  {key: 'OTH', title: 'Autres'},
];

class SignUpTutor extends Component {
  constructor(props) {
    super(props);

    this.emailFieldRef = React.createRef();
    this.firstNameFieldRef = React.createRef();
    this.formationFieldRef = React.createRef();
    this.passwordFieldRef = React.createRef();

    this.state = {
      schools: [],
      isIntroFinished: false, // Intro rules for tutor, only after button click we need to show full form
    };
  }

  // componentWillMount() {
  //   this.props.changeFormModal({title: 'Conditions pour donner des cours chez Clevermate'})
  // }

  isInvalid = ref => {
    if (!ref || !ref.current || !ref.current.checkValidity) return;

    return this.props.formModal.submitted && !ref.current.checkValidity();
  };

  updateSchool = formation => {
    this.props.changeFormModal({ formation, selectedSchool: null });
    this.setState({ schools: [] });

    getSchoolFormationRequest(formation).then(({ schools = [] }) =>
      this.setState({ schools })
    );
  };

  render() {
    return this.state.isIntroFinished ? this.renderMainFormBlock() : this.renderIntroBlock();
  }

  renderIntroBlock() {
    return (
      <Fragment>
        <List>
          <li>Etre Grande Ecole, post prépa ou titulaire d’un BAC + 3 “validé”</li>
          <li>Avoir de l'expérience dans l’enseignement ou une forte appétence pour transmettre et encourager un élève</li>
          <li>Être fièr.e de partager ton savoir et l’envie de t’impliquer sérieusement avec un ou plusieurs élèves</li>
        </List>

        <div className="footer">
          <button
            className="btn btn-primary btn-block btn-large submit-button"
            onClick={ev => {
              this.setState({isIntroFinished: true});
              this.props.changeFormModal({title: 'Inscription prof'});
            }}
          >C’est moi !</button>

          <AlreadyMemberBlock setRoute={this.props.setRoute} />
        </div>
      </Fragment>
    );
  }

  renderMainFormBlock() {
    const {
      formModal,
      changeFormModal,
      setRoute,
      signIn,
      hidePassField,
      isEmailExistCheck,
      editableEmail
    } = this.props;
    const { schools = [] } = this.state;

    return (
      <Fragment>
        <div
          className={`row-space-1 ${
            this.isInvalid(this.emailFieldRef) ? 'error-text' : ''
          }`}
        >
          <input
            type="email"
            ref={this.emailFieldRef}
            value={formModal.email || ''}
            onChange={({ target: { value } }) => {
              changeFormModal({ email: value });
              // setTimeout(() => isEmailExistCheck());
            }}
            onKeyDown={ev => {
              // if (ev.keyCode === 13) {
              //   ev.preventDefault();
              //   this.isEmailExistCheck();
              // }
            }}
            name="email"
            readOnly={!editableEmail}
            className="email"
            placeholder="Entrez votre adresse e-mail"
            autoComplete="user-email"
            required
          />

          {this.isInvalid(this.emailFieldRef) && (
            <p>Vous devez remplir une adresse e-mail valide.</p>
          )}
        </div>

        <div
          className={`row-space-1 ${
            this.isInvalid(this.firstNameFieldRef) ? 'error-text' : ''
          }`}
        >
          <input
            type="text"
            autoComplete="user-first-name"
            ref={this.firstNameFieldRef}
            value={formModal.firstName || ''}
            onChange={({ target: { value } }) =>
              changeFormModal({ firstName: value })
            }
            name="firstName"
            placeholder="Prénom"
            required
          />

          {this.isInvalid(this.firstNameFieldRef) && (
            <p>Vous devez rentrer un prénom.</p>
          )}
        </div>

        <div
          className={`row-space-1 ${
            (this.isInvalid(this.formationFieldRef) ||
              !formModal.selectedSchool) &&
            formModal.submitted
              ? 'error-text'
              : ''
          }`}
        >
          <select
            ref={this.formationFieldRef}
            value={formModal.formation || ''}
            onChange={({ target: { value } }) => this.updateSchool(value)}
            name="formation"
            className="row-space-1"
            required
          >
            <option value="" disabled>Type d'école</option>
            {SCHOOL_TYPES.map(({key, title}) => (
              <option key={key} value={key}>{title}</option>
            ))}
          </select>

          {schools.length > 0 && (
            <SelectSearch
              name="school"
              value={formModal.selectedSchool || ''}
              onChange={({ value }) =>
                changeFormModal({ selectedSchool: value })
              }
              options={schools.map(({ key, name }) => ({ value: key, name }))}
              placeholder="Choix d\'une école"
              required
            />
          )}

          {(this.isInvalid(this.formationFieldRef) ||
            !formModal.selectedSchool) &&
            formModal.submitted && (
              <p>Vous devez renseigner une formation et une école.</p>
            )}
        </div>

        {!hidePassField && (
          <div
            className={`row-space-1 ${
              this.isInvalid(this.passwordFieldRef) ? 'error-text' : ''
            }`}
          >
            <input
              type="password"
              autoComplete="user-password"
              ref={this.passwordFieldRef}
              value={formModal.password || ''}
              onChange={({ target: { value } }) =>
                changeFormModal({ password: value })
              }
              name="password"
              placeholder="Mot de passe"
              required
              pattern=".{5,}"
            />

            {this.isInvalid(this.passwordFieldRef) && (
              <p>Vous devez rentrer un mot de passe d'au moins 5 caractères.</p>
            )}
          </div>
        )}

        <div className="signup footer">
          <div className="conditions">
            En créant un compte, vous acceptez les{' '}
            <a target="_blank" href="cgu" className="link-red">
              Conditions générales
            </a>{' '}
            de Clevermate.
          </div>

          <button
            className="btn btn-primary btn-block btn-large submit-button"
            disabled={formModal.loading}
            onClick={ev => {
              ev.preventDefault();
              if (formModal.loading) {
                return;
              }
              changeFormModal({ submitted: true });
              signIn('tutor');
            }}
          >
            Inscription{' '}
            {formModal.loading && <i className="fa fa-spinner fa-spin fa-lg" />}
          </button>

          <AlreadyMemberBlock setRoute={setRoute} />

          <p>
            Vous cherchez un prof ?{' '}
            <a
              href="#"
              className="link-red"
              onClick={ev => {
                ev.preventDefault();
                setRoute('signupTutee', 'reset');
              }}
            >
              Inscription élève
            </a>
          </p>
        </div>
      </Fragment>
    );
  }
}

export default SignUpTutor;
